import { bl_inv_stock_conversion_line_RowClass } from '../../../dbschema/bl_inv_stock_conversion_line.model';
import {BaseContainerModel} from '../../base-container.model';


export class StockConversionLineContainerModel extends BaseContainerModel {
  bl_inv_stock_conversion_line: bl_inv_stock_conversion_line_RowClass[] = [];
}
